import { Component, Input, OnInit } from '@angular/core';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { LocLabel } from '../clickable-row-table/models/data-table-config.models';

@Component({
  selector: 'app-details-section',
  templateUrl: './details-section.component.html',
  styleUrls: ['./details-section.component.scss']
})
export class DetailsSectionComponent implements OnInit {
  @Input() headerKey: string | LocLabel | null = null;
  @Input() noHeader: boolean = false;
  @Input() last = false;

  constructor(public rwdService: RWDService) {}

  ngOnInit(): void {}
}
